import { PropsWithChildren } from 'react';

import CurrencyInputUiKit, {
  ICurrencyInput as ICurrencyInputUiKit,
} from '@uikit/currencyInput';

import {
  InputWrapper,
  InputContainer,
  InputHelperLabel,
  InputLeftIconWrapper,
} from './styled';

export interface ICurrencyInput extends Omit<ICurrencyInputUiKit, 'value'> {
  helperRightLabel: string;
  value: ICurrencyInputUiKit['value'];
  leftIcon?: React.ReactNode;
}

const CurrencyInput = ({
  helperRightLabel,
  value,
  leftIcon,
  ...rest
}: PropsWithChildren<ICurrencyInput>) => {
  return (
    <InputWrapper>
      <InputContainer>
        {leftIcon && <InputLeftIconWrapper>{leftIcon}</InputLeftIconWrapper>}
        <CurrencyInputUiKit value={value} {...rest} />
      </InputContainer>
      <InputHelperLabel>{helperRightLabel}</InputHelperLabel>
    </InputWrapper>
  );
};

export default CurrencyInput;
